import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useRestrictionDisplayName_bookingRestriction$key } from "./__generated__/useRestrictionDisplayName_bookingRestriction.graphql";

export const useRestrictionDisplayName = (
  restrictionRef?: useRestrictionDisplayName_bookingRestriction$key | null
) => {
  const restriction = useFragment(
    useRestrictionDisplayNameFragmentString,
    restrictionRef
  );
  const trimmedDisplayName = restriction?.displayName?.trim();
  const trimmedName = restriction?.name?.trim();

  return trimmedDisplayName || trimmedName || "";
};

const useRestrictionDisplayNameFragmentString = graphql`
  fragment useRestrictionDisplayName_bookingRestriction on BookingRestriction {
    name
    displayName
  }
`;
